import React, { memo } from 'react';
import DetailField from 'containers/components/EntityDetailPopover/DetailField';

const EnvironmentField = memo(({ value }) => {
    return <DetailField iconProps={{ name: 'branch' }} value={value} />;
});

export default EnvironmentField;
